/**
 * campaign-export — Campaign data EXPORT (XLSX + CSV).
 *
 * NOT a PDF: conf.kind = 'export'. It renders no HTML and never reaches
 * report_publish/report_save — the export is a direct client-side download of
 * the campaign's lead data in the platform's fixed 50-column template.
 * The Report Studio swaps its PDF preview for the export panel; the campaign
 * card menu mounts the same panel.
 */
import { CAMPAIGN_REVISION, validateCampaignReport } from '../../schema/campaign';

export const conf = {
  id: 'campaign-export',
  name: 'Campaign Export',
  description: 'Download the campaign lead data as Excel or CSV — the standard 50-column template.',
  revision: CAMPAIGN_REVISION,
  sourceKinds: ['campaign'] as const,
  pdfBucket: 'campaign-report-exports' as const,
  sectionConfig: false,
  i18n: 'dictionary' as const,
  kind: 'export' as const,
};

/**
 * Export templates do not participate in the document render pipeline. The
 * registry's discriminated union keeps this template out of the render/validate
 * text flow; validate is kept (payload sanity for the panel's count display).
 */
export const reportTemplate = {
  conf,
  validate: validateCampaignReport,
};
